/* eslint-disable */
/**
 * AUTO-GENERATED FILE — DO NOT EDIT.
 *
 * Generated by: scripts/generate-embedded-react-exports.mjs
 * Source: react-dom@19.2.4 (ESM entry)
 * Generated at: 2026-03-01T21:44:18.124Z
 */

export const EMBEDDED_REACT_DOM_19_VERSION = "19.2.4" as const;

export const EMBEDDED_REACT_DOM_19_NAMED_EXPORTS = [
  "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE",
  "createPortal",
  "createRoot",
  "flushSync",
  "hydrateRoot",
  "preconnect",
  "prefetchDNS",
  "preinit",
  "preinitModule",
  "preload",
  "preloadModule",
  "requestFormReset",
  "unstable_batchedUpdates",
  "useFormState",
  "useFormStatus",
  "version"
] as const;
